const driverDataEndpoints = {
  list: (companyId: string) => `/companies/${companyId}/budgeting/drivers/data` as const
}

export default driverDataEndpoints
